<template>
	<div v-if="!LOGINSTATUS" class="app-header">
		<div class="flex items-center " style="float:left;">
			<div style="width:50px;" v-if="currentAccountSets">
				<Button :icon="sliderCollapsed ? 'icon-align-right':'icon-align-left'" size="l" noBorder class="font20" @click="sliderCollapsed=!sliderCollapsed"></Button>
			</div>
			<app-header-account-sets class="ml-10px"/>

			<img v-if="currentAccountSets" src="../../assets/index/加.png" style="margin-right: 20px" @click="showForm()">

			<img v-if="currentAccountSets" src="../../assets/index/设置.png" style="margin-right: 20px" @click="goForm()">

			<div class="h-input-group" style="line-height: normal">
				<span style="font-weight: bold; color: black">{{currentAccountDate}}</span>
			</div>
		</div>
		<span class="app-header-icon-item ml-20px text-14px" v-if="expirationDay<=31 && currentAccountSets" style="font-weight: bold; color: black">
			<template v-if="expirationDay">使用期仅剩<b class="font-bold red-color">{{ expirationDay }}天！</b></template>
			<Button text-color="#006dfd" size="xs" @click="goWorkbench"  noBorder >点我激活！</Button>
      		<!-- <Button @click="goWorkbench" transparent style="background-color: #006dfd; color: white; border-radius: 6px" class="h-btn h-btn-s">立即购买</Button> -->
    	</span>

		<div class="float-right app-header-info mr-16px">
			<!-- <Button @click="openedPhone=true" size="xs"  noBorder  icon="h-icon-home">手机登录</Button> -->
			<Modal v-model="openedLock" v-bind="paramsLock">
				<div class="header-modal-app-in" style="width: 100%; height: 100%; background: black; display: flex; justify-content: center; align-items: center;">
					<div>
						<div style="padding: 10px;"><h2 style="text-align: center;color: aliceblue">请输入密码进行解锁！</h2></div>

						<div style="padding: 10px;"><Input @keyup.enter.native="submit" v-model="login.password" placeholder="请输入密码！" type="password" class="login-input"/></div>
						
						<div style="padding: 10px;display: flex;justify-content: center;"><Button color="blue" @click="submit" style="width: 80px;box-shadow:none;">确 定</Button></div>
					</div>
				</div>
			</Modal>
			<Button  @click="openAIChat" size="xs"  noBorder  icon="h-icon-task">智能问答</Button>
			<Button  @click="lockClick" size="xs"  noBorder  icon="h-icon-lock">锁定屏幕</Button>
			<Button  @click="openedDown=true" size="xs"  noBorder  icon="h-icon-menu">下载桌面</Button>
			<Modal v-model="openedDown" v-bind="params">
				<div class="header-modal-app-in">请按系统版本选择下载</div>
				<div>
					<div class="header-modal-app-in-2">
						<div onclick="window.open('https://kdocs.cn/l/ceXDhXZtflSa')" style="width: 100%; height: 40px; line-height: 40px; font-size: 14px; text-align: center; cursor: pointer;">WIN7 系统下载</div>
						<div onclick="window.open('https://kdocs.cn/l/ceXDhXZtflSa')" style="width: 100%; height: 40px; line-height: 40px; font-size: 14px; text-align: center; cursor: pointer;">WIN10 系统下载</div>
						<div onclick="window.open('https://kdocs.cn/l/ceXDhXZtflSa')" style="width: 100%; height: 40px; line-height: 40px; font-size: 14px; text-align: center; cursor: pointer;">WIN11 系统下载</div>
					</div>
				</div>
			</Modal>

			<Button  size="xs" @click="openHelp()"  noBorder  icon="h-icon-help">帮助中心</Button>

			<Button  @click="openedQQ=true" size="xs"  noBorder  icon="h-icon-users">在线客服</Button>
			<Modal v-model="openedQQ" v-bind="params">
				<div class="header-modal-app-in">客服在线时间：9:00-18:00</div>
				<div style="display: flex;justify-content: center;">
					<div style="padding: 0 15px;">
						<a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=1728363817&site=qq&menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:1728363817:53" alt="点击这里给我发消息" title="点击这里给我发消息"/></a>
						<p>QQ:1728363817</p>
					</div>
					<div style="padding: 0 15px;">
						<a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=282520741&site=qq&menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:282520741:53" alt="点击这里给我发消息" title="点击这里给我发消息"/></a>
						<p>QQ:282520741</p>
					</div>
				</div>
			</Modal>
			<!-- <a href="http://www.jhqkg.com" target="_blank" class="topic-text">官网</a> -->
			<!-- <DropdownMenu class="topic-text" :datas="helpMenu" @clickItem="helpTrigger">
				<span>帮助</span>
			</DropdownMenu> -->
			<!-- <span class="topic-text" @click="showImage(imageStatus)">客服</span>
			<a class="topic-text" @click="showPhone(phoneStatus)" >售后</a> -->
			<!-- jxd后台 -->
			<!-- <span v-if="currentAccountSets" class="topic-text" @click="goWorkbench">工作台</span> -->
			<Button v-if="currentAccountSets"  size="xs" @click="goWorkbench"  noBorder  icon="h-icon-menu">控制台</Button>
			<!-- 
			<DropdownMenu :datas="moreMenu" @clickItem="moreTrigger">
				<span>更多</span>
			</DropdownMenu> -->

			<!-- <img @click="showImage(imageStatus)" v-if="imageStatus" class="topic-contact" src="../../assets/code.jpg" alt="客服">
			<span @click="showPhone(phoneStatus)" v-if="phoneStatus" class="topic-phone-contact">紧急联系点击：18329078628</span> -->

			<DropdownMenu className="app-header-dropdown" trigger="hover" offset="0 5" :width="150" placement="bottom-end" :datas="infoMenu" @clickItem="trigger">
				<Avatar :src="avatarUrl" :width="30"><span>{{ User.realName }}</span></Avatar>
			</DropdownMenu>
		</div>
	</div>
	<div v-else>
		<span class="app-header-icon-item ml-20px text-19px" style="color: black">
      		企业控制台
    	</span>
		<div class="float-right app-header-info mr-16px">
			<DropdownMenu className="app-header-dropdown" trigger="hover" offset="0 5" :width="150" placement="bottom-end" :datas="infoMenu" @clickItem="trigger">
				<Avatar :src="avatarUrl" :width="30"><span>{{ User.realName }}</span></Avatar>
			</DropdownMenu>
		</div>
	</div>
</template>
<script>
	import {h} from 'vue';
	import {mapGetters, mapState} from 'vuex';
	import manba from 'manba';
	import appHeaderMessage from './modules/app-header-message';
	import AppHeaderAccountSets from "./modules/app-header-account-sets";
	import {layer} from "@layui/layer-vue";
	import Index from "@/views/personal/Index";
	import Renewal from "@/views/app/Renewal";
	import setting from "@api/setting";
	import AccountForm from "@/views/setting/account/AccountForm";

	const DEFAULT_VALUE_LOCK = {
		closeOnMask: false,
		fullScreen: true,
		middle: false,
		hasMask: false,
		hasDivider: false,
		hasCloseIcon: false,
		draggable: false
	};
	const DEFAULT_VALUE = {
		closeOnMask: true,
		fullScreen: false,
		middle: true,
		hasMask: true,
		hasDivider: false,
		hasCloseIcon: false,
		draggable: false
	};
	export default {
		components: {
			AppHeaderAccountSets,
			appHeaderMessage
		},
		data() {
			return {
				paramsLock: {
					...DEFAULT_VALUE_LOCK,
				},
				openedLock: false,
				login:{password:'',account:''},
				params: {
					...DEFAULT_VALUE
				},
				expirationDay:1,//jxd实际相差日期，也就是剩余可用天数
				openedQQ:false,
				openedDown:false,
				openedPhone: false,
				searchText: '',
				currentAccountDate: null,
				imageStatus: false,
				phoneStatus: false,
				helpMenu: [
					{key: 'key1', title: '官网首页'},
					{key: 'key2', title: '计算器'},
					{key: 'key3', title: '个税计算器'},
					{key: 'key4', title: '查询导航'},
					{key: 'key5', title: '分类大全'}
				],
				moreMenu: [
					{key: 'key1', title: '官网首页'},
					{key: 'key2', title: '计算器'},
					{key: 'key3', title: '个税计算器'},
					{key: 'key4', title: '查询导航'},
					{key: 'key5', title: '分类大全'}
				],
				infoMenu: [
					{key: 'info', title: '个人信息', icon: 'h-icon-user'},
					{key: 'logout', title: '退出登录', icon: 'h-icon-outbox'}
				],
				LOGINSTATUS: null
			};
		},
		computed: {
			...mapState(['User', 'currentAccountSets']),
			...mapGetters(['checkoutList']),
			sliderCollapsed: {
				get() {
					return this.$store.state.sliderCollapsed;
				},
				set(value) {
					this.$store.commit('updateSliderCollapse', value);
				}
			},
			accountDate() {
				return this.currentAccountSets ? manba(this.currentAccountSets.currentAccountDate).format("YYYY年MM月") : null;
			},
			avatarUrl() {
				return this.User.avatarUrl || '/images/yun.png'
			},
			dOp() {
				let filter = this.checkoutList.filter(val => val.status !== 2);
				return {
					start: filter[filter.length - 1].checkDate,
					end: filter[0].checkDate,
				}
			}
		},
		watch: {
			accountDate() {
				this.currentAccountDate = this.accountDate;
			}
		},
		mounted() {
			this.currentAccountDate = this.accountDate;
			const resizeEvent = window.addEventListener('resize', () => {
				if (this.sliderCollapsed && window.innerWidth > 900) {
					this.sliderCollapsed = false;
				} else if (!this.sliderCollapsed && window.innerWidth < 900) {
					this.sliderCollapsed = true;
				}
				if (!this.currentAccountSets) {
					this.sliderCollapsed = true;
				}
			});
			window.dispatchEvent(new Event('resize'));
			if(localStorage.getItem('lock' + this.User.mobile)){
				this.openedLock = true;
			}
		},
		methods: {
			// 打开AI聊天窗口（新增方法）
			openAIChat() {
				if (window.$app && window.$app.openAIChat) {
					window.$app.openAIChat();
				}
			},
			lockClick(){
				this.openedLock=true;
				this.login.password='';
				localStorage.setItem('lock' + this.User.mobile,this.User.mobile);
			},
			submit(){
				console.log(this.User.mobile)
				this.login.account = this.User.mobile
				this.$api.common.lock(this.login).then((res) => {
					if(res.code == 200){
						this.$Message({
							type:'success',
							text: `解锁成功！`
						});
						localStorage.removeItem('lock' + this.User.mobile);
						this.openedLock = false;
					}
				}).catch(() => {
					this.$Message({
						type:'warn',
						text: `解锁失败！`
					});
				});
			},
			openHelp(){
				window.open("/help.html", '_blank');
			},
			dateDiffInDays(dateStr1, date2 = new Date()) {  
				 // 将字符串转换为Date对象  
				let date1 = new Date(dateStr1); 
				// 确保输入的是有效的日期对象  
				if (!(date1 instanceof Date) || !(date2 instanceof Date)) {  
					throw new Error('Invalid date objects');  
				}  
				// 计算两个日期之间的毫秒差  
				var diff = Math.abs(date2 - date1);  
				// 将毫秒差转换为天数  
				var days = Math.ceil(diff / (1000 * 60 * 60 * 24));  
				// 返回天数差  
				return days;  
			}, 
			helpTrigger(data) {
				if (data === 'key1') {

				} else if (data === 'key2') {

				} else if (data === 'key3') {

				} else if (data === 'key4') {

				} else if (data === 'key5') {

				}
			},
			moreTrigger(data) {
				if (data === 'key1') {

				} else if (data === 'key2') {

				} else if (data === 'key3') {

				} else if (data === 'key4') {

				} else if (data === 'key5') {

				}
			},
			trigger(data) {
				if (data === 'logout') {
					this.$api.common.logout().then(() => {
						window.location.replace("/");
					});
				} else {
					layer.open({
						title: "个人信息设置",
						shadeClose: false,
						zIndex: 999,
						area: ['700px', '500px'],
						content: h(Index)
					});
				}
			},
			doRenewal() {
				const layerId = layer.open({
					title: "账号续期",
					shadeClose: false,
					closeBtn: false,
					zIndex: 1000,
					area: ['500px', 'auto'],
					content: h(Renewal, {
						onClose() {
							layer.close(layerId);
						},
						onSuccess() {
							layer.close(layerId);
						}
					})
				});
			},
			accountDateChange(val) {
				let date = manba(val.replace("年", "-").replace("月", "-") + "01").format();
				setting.accountSets.updateCurrentAccountDate(date).then(() => {
					this.$store.dispatch('init');
				})
			},
			showForm(entity = null) {
				if(this.User.role != 'ManagerBase' && this.User.role != 'ManagerMajor' && this.User.role != 'ManagerFlagship' && this.User.role != 'ManagerApexe' && this.User.role != 'ManagerLow'){
					this.$Message({
						type:'warn',
						text: `你不是账套管理员，无此权限！`
					});
					return;
				}
				let layerId = layer.open({
					title: "账套信息",
					shadeClose: false,
					closeBtn: false,
					zIndex: 999,
					area: ['900px', '370px'],
					content: h(AccountForm, {
						entity,
						onClose: () => {
							layer.close(layerId);
						},
						onSuccess: () => {
							this.init();
							this.loadList();
							layer.close(layerId);
						}
					})
				});
			},
			goForm() {
				if(this.User.role != 'ManagerBase' && this.User.role != 'ManagerMajor' && this.User.role != 'ManagerFlagship' && this.User.role != 'ManagerApexe' && this.User.role != 'ManagerLow'){
					this.$Message({
						type:'warn',
						text: `你不是账套管理员，无此权限！`
					});
					return;
				}
				this.$store.commit('newTab', {key: "Account", title: "账套"})
			},
			showImage (imageStatus) {
				this.imageStatus = imageStatus !== true;
			},
			showPhone (phoneStatus) {
				this.phoneStatus = phoneStatus !== true;
			},
			goWorkbench() {
				if(this.User.role != 'ManagerBase' && this.User.role != 'ManagerMajor' && this.User.role != 'ManagerFlagship' && this.User.role != 'ManagerApexe' && this.User.role != 'ManagerLow'){
					this.$Message({
						type:'warn',
						text: `你不是账套管理员，无此权限！`
					});
					return;
				}
				localStorage.setItem('LOGINSTATUS', 'LOGINSTATUS')
				this.$store.commit('newTab', {key: "ProductActivation", title: ""})
				window.location.replace('/')
			}
		},
		created() {
			this.expirationDay = this.dateDiffInDays(this.User.expirationDate);
			this.LOGINSTATUS = localStorage.getItem("LOGINSTATUS")
		}
	};
</script>
<style lang="less">

	.app-header {
		color: rgba(49, 58, 70, 0.8);

		.h-autocomplete {
			line-height: 1.5;
			float: left;
			margin-top: 15px;
			margin-right: 20px;
			width: 120px;

			&-show, &-show:hover, &-show.focusing {
				outline: none;
				box-shadow: none;
				border-color: transparent;
				border-radius: 0;
			}

			&-show.focusing {
				border-bottom: 1px solid #eee;
			}
		}

		&-info &-icon-item {
			cursor: pointer;
			display: inline-block;
			float: left;
			padding: 0 15px;
			height: @layout-header-height;
			line-height: @layout-header-height;
			margin-right: 10px;

			&:hover {
				background: @hover-background-color;
			}

			i {
				font-size: 18px;
			}

			a {
				color: inherit;
			}

			.h-badge {
				margin: 20px 0;
				display: block;
			}
		}

		.app-header-icon-item {
			margin-left: 20px;

			button {
				background-color: #ffffff;
			}
		}

		.topic-text {
			margin-right: 20px;
			cursor: pointer;
		}

		.topic-contact {
			position: fixed;
			z-index: 2000;
			height: 360px;
		}

		.topic-phone-contact {
			color: red;
			font-weight: bold;
			font-size: 16px;
			text-align: center;
			border: 3px solid black;
			border-radius: 8px;
			position: fixed;
			z-index: 1000;
			line-height: 40px;
			width: 240px;
			left: 78%;
			top: 60px;
		}

		&-dropdown {
			float: right;
			margin-left: 10px;
			padding: 0 5px 0 15px;

			.h-icon-down {
				right: 20px;
			}

			cursor: pointer;

			&:hover, &.h-pop-trigger {
				background: @hover-background-color;
			}

			&-dropdown {
				padding: 5px 0;

				.h-dropdownmenu-item {
					padding: 8px 20px;
				}
			}
		}

		&-menus {
			display: inline-block;
			vertical-align: top;

			> div {
				display: inline-block;
				font-size: 15px;
				padding: 0 25px;
				color: @dark-color;

				&:hover {
					color: @primary-color;
				}

				+ div {
					margin-left: 5px;
				}

				&.h-tab-selected {
					color: @white-color;
					background-color: @primary-color;
				}
			}
		}
	}
	.header-modal-app-in{
		margin-bottom: 20px;
    	font-size: 16px;
   	 	border-bottom: 1px solid;
	}
	.header-modal-app-in-1{
		display: flex;
		justify-content: center;
	}
	.header-modal-app-in-2{
		display: flex;
		flex-direction: column;
	}
</style>
